import React from "react";
import { Button } from "reactstrap";

export const PayButton = () => {
  return (
    <div>
      <Button color="success">Support a Creator</Button>
    </div>
  );
};
